/* Halloween 2026: product page panel - live countdown + Halloween price that follows the selected variant. */
(function () {
  'use strict';
  var notes = document.querySelectorAll('[data-hw26-note]');
  if (!notes.length) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    notes.forEach(function (note) {
      var end = parseInt(note.getAttribute('data-end'), 10) * 1000;
      var left = Math.max(0, end - Date.now());
      var d = Math.floor(left / 86400000);
      var h = Math.floor(left / 3600000) % 24;
      var m = Math.floor(left / 60000) % 60;
      var s = Math.floor(left / 1000) % 60;
      var el = note.querySelector('[data-hw26-timer]');
      if (el) el.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      if (left === 0) note.style.display = 'none';
    });
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    return '$' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + v[1];
  }

  function currentCents(scope) {
    var price = scope.querySelector('.m-price');
    if (!price) return null;
    var item = price.classList.contains('m-price--on-sale')
      ? price.querySelector('.m-price__sale .m-price-item--sale')
      : price.querySelector('.m-price__regular .m-price-item--regular');
    item = item || price.querySelector('.m-price-item');
    if (!item) return null;
    var txt = (item.textContent || '').replace(/[^0-9.,]/g, '');
    if (!txt) return null;
    if (/,\d{2}$/.test(txt) && txt.indexOf('.') === -1) txt = txt.replace(',', '.');
    txt = txt.replace(/,/g, '');
    var n = parseFloat(txt);
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function bindPrice(note) {
    var group = note.previousElementSibling;
    while (group && !group.querySelector('.m-price') && !group.classList.contains('product-block-group--price')) {
      group = group.previousElementSibling;
    }
    if (!group) return;
    var target = note.querySelector('[data-hw26-price]');
    var update = function () {
      var c = currentCents(group);
      if (c && target) target.textContent = money(c - Math.round(c * 0.15));
    };
    new MutationObserver(update).observe(group, { subtree: true, childList: true, characterData: true, attributes: true });
    update();
  }

  notes.forEach(bindPrice);
  tick();
  setInterval(tick, 1000);
})();
